'use strict';

// Import all modules

import { team } from './team.js';
import { popups } from './popups.js';
import { search, highlightSearchTerms } from './search.js';
import { tagSearch } from './tag-search.js';
import { initializeSliderMiniHome, initEventSlider, initTestimonialSlider } from './slider.js';
import { menuToggleTweak } from './menu.js';
import { dataBackgrounds } from './backgrounds.js';
import { displaySearchForm } from './search-form.js';
import { initializeNavigation } from './navigation.js';
import { floatingNav } from './floating-nav.js';
import { handleAnchor } from './anchors.js';
import { targetAnchor } from './anchors.js';
import { accordion } from './accordion.js';
import { footerAccordion } from './footer-accordion.js';
import { videoModal } from './video-modal.js';
import { loopFilter } from './loop-filter.js';
import { setupNewsletterButton } from './newsletter.js';
import { designResources } from './design-resources.js';
import { initPaycorMooveEmbed } from './paycor-moovegdpr.js';


(function ($) {
  'use strict';

  // Initialize all modules
  document.addEventListener('DOMContentLoaded', function () {
    // Handle anchors when the page loads
    if (window.location.hash) {
      setTimeout(function () {
        handleAnchor(window.location.hash);
      }, 250);
    }

    menuToggleTweak();
    dataBackgrounds();
    popups();
    team();
    search();
    initializeSliderMiniHome();
    initEventSlider();
    initTestimonialSlider();
    displaySearchForm();
    initializeNavigation();
    floatingNav();
    accordion();
    footerAccordion();
    videoModal();
    tagSearch();
    loopFilter();
    setupNewsletterButton();
    targetAnchor();
    highlightSearchTerms();
    designResources();
    
    initPaycorMooveEmbed ({
      bodyClass: 'page-careers', 
      containerSelector: '#paycor-embed',
      src: '//newton.newtonsoftware.com/career/iframe.action?clientId=8a7883c6712ca1f9017136f08c8803d3',
    });

    jQuery(window).on('resize', initEventSlider);
  });

  window.addEventListener('hashchange', function () {
    // Handle anchors when the hash changes
    handleAnchor(window.location.hash);
  });
})(jQuery);
